module.exports = __webpack_public_path__ + "img/dep_butcher@2x.39640e00.png";